<template>
  <base-section-layout
    title="EMS 护照邮寄"
    icon="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-www/order/order-interview-notification/section-email.png"
  >
    <div class="section-text">
      需提前在线支付<span class="c-red">150元护照邮寄服务费用</span
      >（申请人自费承担，具体费用以实际收取为准）。申请人可于面试后自行完成支付，或选择在出签后由我司代为缴纳，届时需联系签证专家补缴相关费用。
    </div>
  </base-section-layout>
</template>

<script>
import BaseSectionLayout from './BaseSectionLayout.vue';

export default {
  name: 'SectionEmsReminder',
  components: {
    BaseSectionLayout,
  },
};
</script>

<style lang="less" scoped>
.section-text {
  color: #666;
  font-size: 12px;
  line-height: 21px;
  word-break: break-all;

  .c-red {
    color: #ff4b4d;
  }
}
</style>
